/* assets/section-award-marquee.js */
if (!customElements.get('award-marquee')) {
  class AwardMarquee extends HTMLElement {
    connectedCallback() {
      this.rows = this.querySelectorAll('[data-award-marquee-row]');
      this.pauseOnHover = this.hasAttribute('data-pause-on-hover');
      this.onItemEnter = this.onItemEnter.bind(this);
      this.onItemLeave = this.onItemLeave.bind(this);
      this.bindEvents();
    }

    disconnectedCallback() {
      this.unbindEvents();
    }

    bindEvents() {
      if (!this.pauseOnHover) return;

      this.querySelectorAll('.award-marquee__item').forEach((item) => {
        item.addEventListener('mouseenter', this.onItemEnter);
        item.addEventListener('mouseleave', this.onItemLeave);
        item.addEventListener('focusin', this.onItemEnter);
        item.addEventListener('focusout', this.onItemLeave);
      });
    }

    unbindEvents() {
      this.querySelectorAll('.award-marquee__item').forEach((item) => {
        item.removeEventListener('mouseenter', this.onItemEnter);
        item.removeEventListener('mouseleave', this.onItemLeave);
        item.removeEventListener('focusin', this.onItemEnter);
        item.removeEventListener('focusout', this.onItemLeave);
      });
    }

    onItemEnter() {
      this.rows.forEach((row) => row.classList.add('is-paused'));
    }

    onItemLeave() {
      this.rows.forEach((row) => row.classList.remove('is-paused'));
    }
  }

  customElements.define('award-marquee', AwardMarquee);
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('award-marquee').forEach((el) => {
    if (typeof el.disconnectedCallback === 'function') el.disconnectedCallback();
    if (typeof el.connectedCallback === 'function') el.connectedCallback();
  });
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('award-marquee').forEach((el) => {
    if (typeof el.disconnectedCallback === 'function') el.disconnectedCallback();
  });
});
